import css from 'styled-jsx/css';

const styles = css.global`#bens-servicos-pf-confira-passo-a-passo {
  overflow: hidden;
  background: #FBFBFB;
  position: relative;
}

#bens-servicos-pf-confira {
  padding: 40px 0;
}

#bens-servicos-pf-confira-passo-a-passo .confira-title {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
  margin-bottom: 32px;
}

#bens-servicos-pf-confira-passo-a-passo .confira-carrossel-slide {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 198.621px;
  height: 192px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #CCC;
  background: #C00;
  flex: 0 0 198.621px;
  margin-right: 16px;
}

#bens-servicos-pf-confira-passo-a-passo .confira-carrossel-slide .slide-texto {
  color: #FFF;
  text-align: center;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#bens-servicos-pf-confira-passo-a-passo .home-pagination {
  margin-top: 24px;
}

#bens-servicos-pf-confira-passo-a-passo .home-pagination .embla__prev.enable-mobile-arrows, 
#bens-servicos-pf-confira-passo-a-passo .home-pagination .embla__next.enable-mobile-arrows {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

#bens-servicos-pf-passo-a-passo {
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
  /* position: relative; */
}

#bens-servicos-pf-passo-a-passo .passo-a-passo-titles {
  display: flex;
  flex-direction: column;
  gap: 10px;
} 

#bens-servicos-pf-passo-a-passo .passo-a-passo-title {
  color:#444;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

#bens-servicos-pf-passo-a-passo .passo-a-passo-subtitle {
  color: #222;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#bens-servicos-pf-passo-a-passo .passo-a-passo-passos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#bens-servicos-pf-passo-a-passo .passo-a-passo-passo, 
#bens-servicos-pf-passo-a-passo .passo-a-passo-passo a {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#bens-servicos-pf-passo-a-passo .passo-a-passo-passo a {
  text-decoration: underline;
}

#bens-servicos-pf-passo-a-passo .passo-a-passo-passo b {
  color: #C00;
  font-family: "SantanderText";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
}


#bens-servicos-pf-passo-a-passo .img-passo-a-passo {
  position: absolute;
  right: -15px;
  bottom: -70px;
}



@media (min-width: 992px) {
   #bens-servicos-pf-confira {
    padding: 24px 0;
  }

  #bens-servicos-pf-confira-passo-a-passo .confira-title {
    font-size: 40px;
    line-height: 60px;
    margin-bottom: 40px;
  }

  #bens-servicos-pf-confira-passo-a-passo .confira-carrossel {
    overflow: hidden;
  }

  #bens-servicos-pf-confira-passo-a-passo .confira-carrossel-slide {
   margin-right: 32px;
  }

  #bens-servicos-pf-confira-passo-a-passo .home-pagination {
    margin-top: 48px;
  }

  #bens-servicos-pf-passo-a-passo .img-passo-a-passo {
    position: absolute;
    right: -45px;
    bottom: auto;
    top: 0;
  }
}`;

export default styles;